/* eslint-disable func-names */
import { isNaN } from 'lodash';
import * as yup from 'yup';
import Lang from './language';

yup.setLocale({ mixed: { required: Lang.MSG_ERROR_REQUIRED } });

yup.addMethod<yup.StringSchema>(yup.string, 'requiredIfEmpty', function (list) {
  return this.test(
    'requiredIfEmpty',
    Lang.MSG_ERROR_REQUIRED,
    function (value) {
      const hasValue = list.some((item) => this.parent[item]);

      return value || hasValue;
    }
  );
});

yup.addMethod<yup.NumberSchema>(yup.number, 'requiredIfEmpty', function (list) {
  return this.test(
    'requiredIfEmpty',
    Lang.MSG_ERROR_REQUIRED,
    function (value) {
      const hasValue = list.some((item) => this.parent[item]);

      return value || hasValue;
    }
  );
});

yup.addMethod<yup.NumberSchema>(yup.number, 'notNaN', function () {
  return this.transform((value) => (isNaN(value) ? undefined : value));
});

yup.addMethod<yup.ObjectSchema>(
  yup.object,
  'optional',
  function (isOptional = true, defaultValue = undefined) {
    return this.transform((_, value) => {
      if (!isOptional) {
        return value;
      }

      if (
        value &&
        Object.values(value).some(
          (v) => !(v === null || v === undefined || v === '')
        )
      ) {
        return value;
      }
      return defaultValue;
    }).default(defaultValue);
  }
);

yup.addMethod<yup.NotRequiredArraySchema<any>>(
  yup.array,
  'requiredIfValue',
  function (field: string, match = undefined) {
    return this.test(
      'requiredIfValue',
      Lang.MSG_ERROR_REQUIRED,
      function (value) {
        return (
          (this.parent[field] !== undefined && this.parent[field] !== match) ||
          this.parent[field] === undefined ||
          (this.parent[field] !== undefined && value !== undefined)
        );
      }
    );
  }
);

declare module 'yup' {
  interface StringSchema<T> {
    requiredIfEmpty(
      this: yup.StringSchema<T>,
      list: string[]
    ): yup.StringSchema<T>;
  }

  interface NumberSchema<T> {
    requiredIfEmpty(
      this: yup.NumberSchema<T>,
      list: string[]
    ): yup.NumberSchema<T>;

    notNaN(this: yup.NumberSchema<T>): yup.NumberSchema<T>;
  }

  interface ObjectSchema<T> {
    optional(
      this: yup.ObjectSchema<T>,
      isOptional: boolean,
      defaultValue?: any
    ): yup.ObjectSchema<T>;
  }

  interface NotRequiredArraySchema<T> {
    requiredIfValue(
      this: yup.NotRequiredArraySchema<T>,
      field: string,
      value: any
    ): yup.NotRequiredArraySchema<T>;
  }
}

export default yup;
